import { useMemo } from 'react';
import { SELECTED_CROP_SEASONS_STORAGE_KEY as STORAGE_KEY } from 'utilities/cropSeasonUrl';

const parseSelectedCropSeasonIds = (raw: string | null): string[] => {
  if (raw === null) return [];
  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((id): id is string => typeof id === 'string');
  } catch {
    return [];
  }
};

const useSelectedCropSeasonIds = () => {
  const storageValue = globalThis?.window?.localStorage
    ? localStorage.getItem(STORAGE_KEY)
    : null;

  /**
   * @description
   * Returns the selected crop season ids from localStorage
   * @returns The selected crop season ids
   */
  const selectedCropSeasonIds = useMemo(
    () => parseSelectedCropSeasonIds(storageValue),
    [storageValue]
  );

  /**
   * @description
   * Checks if all the given crop season ids are selected
   * @param cropSeasonIds - The crop season ids to check
   * @returns True if all the given crop season ids are selected, false otherwise
   */
  const hasAllSelectedCropSeasonIds = (cropSeasonIds: string[]) => {
    return cropSeasonIds.every(id => selectedCropSeasonIds.includes(id));
  };

  return { selectedCropSeasonIds, hasAllSelectedCropSeasonIds };
};

export default useSelectedCropSeasonIds;
